export const isTokenExpired = (accessToken) => {
  try {
    const tokenJSON = JSON.parse(atob(accessToken.split('.')[1]));
    const currentTimestamp = Math.floor(Date.now() / 1000);
    return currentTimestamp >= tokenJSON.exp;
  } catch (error) {
    console.log('Error occurred while parsing the token:', error);
    return true; // or throw a custom error
  }
};

export const getLoggedInUser = (accessToken) => {
  try {
    return JSON.parse(window.atob(accessToken.split('.')[1]));
  } catch (error) {
    return {error};
  }
};
